<template>
    <component :is="formStep"></component>
</template>

<script>
    export default {
        name: 'BaseStep',
        props: {
            step: {
                type: Number,
                required: true
            },
            steps: {
                type: Array,
                required: true
            }
        },
        computed: {
            formStep() {
                return this.steps[this.step - 1];
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/main/pages/base/BaseStep.vue